import React from 'react';
import './footer.css';

const Footer = () => {

  const services = [

  "Growth Marketing Ecosystem",

  "Creative & Content Powerhouse",

  "Digital Infrastructure",

  "Data Intelligence & Insights",

  "AI-Powered Growth Systems",

  "Brand Strategy & Positioning",

  "Production & Visuals",

  "PR, Media & Offline Impact",

  "Revenue & Growth Systems"

];
  return (

    <footer className="footer">

      <div className="footer-container">

        {/* BRAND */}

        <div className="footer-col brand-col">

          <img
            src="/wcs-logo.png"
            alt="WeCanServe Logo"
            className="footer-logo"
          />

          <p>
            WeCanServe helps brands scale through
            digital marketing, websites, branding,
            AI automation and impactful campaigns.
          </p>

<div className="social-links">

  <a
    href="https://www.instagram.com/wecanserve.in?utm_source=qr&igsh=cWZsaXJtbHJ3OWQ0"
    target="_blank"
    rel="noreferrer"
  >
    <i className="ri-instagram-line"></i>
  </a>

  {/* <a
    href="https://www.linkedin.com"
    target="_blank"
    rel="noreferrer"
  >
    <i className="ri-linkedin-fill"></i>
  </a> */}

  <a
    href="https://www.facebook.com/share/1BUxYJMn73/?mibextid=wwXIfr"
    target="_blank"
    rel="noreferrer"
  >
    <i className="ri-facebook-circle-fill"></i>
  </a>

</div>

        </div>

        {/* QUICK LINKS */}

        <div className="footer-col">

          <h4>Quick Links</h4>

          <ul>

            <li>
              <a href="/">Home</a>
            </li>

            <li>
              <a href="/about">About Us</a>
            </li>

            <li>
              <a href="/services">Services</a>
            </li>

            <li>
              <a href="/portfolio">Portfolio</a>
            </li>

            <li>
              <a href="/contact">Contact Us</a>
            </li>

          </ul>

        </div>

        {/* SERVICES */}

        <div className="footer-col services-column">

          <h4>Services</h4>

          <ul>

            {services.map((service, index) => (

              <li key={index}>

                <a href="/services">
                  {service}
                </a>

              </li>

            ))}

          </ul>

        </div>

        {/* CONTACT */}

        <div className="footer-col">

          <h4>Contact</h4>

          <p>Mumbai, India</p>
          <br />

          <p>info@wecanserve.com</p>
          <br />

          <p>+91 9112135150</p>

        </div>

      </div>

      {/* BOTTOM */}

      <div className="footer-bottom">

        <p>
          © 2026 WeCanServe. All Rights Reserved.
        </p>

      </div>

    </footer>

  );

};

export default Footer;